/**
 * ExitConfirmDialog — confirms the user really wants to leave when there
 * are unsaved actions. Mirrors openExitConfirmDialog from EstadisticasNew.js.
 */

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useStatsTheme } from '../../theme/statsTheme';

export default function ExitConfirmDialog({ open, onCancel, onConfirm, t }) {
  const theme = useStatsTheme();
  const tt = (key, fallback) => (typeof t === 'function' ? t(`estadisticasNew.${key}`, { defaultValue: fallback }) : fallback);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: theme.surfaces.elevated,
          color: theme.text.primary,
          border: `1px solid ${theme.surfaces.border}`,
          borderRadius: theme.radius.xl,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon sx={{ color: theme.actionColors.warning }} />
        {tt('exitTitle', 'Unsaved data')}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 13, color: theme.text.secondary }}>
          {tt('exitWarning', 'You have unsaved actions. Are you sure you want to leave? They will be lost.')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} sx={{ color: theme.text.secondary }}>
          {tt('cancel', 'Cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: theme.actionColors.missed,
            '&:hover': { backgroundColor: theme.actionColors.missed },
          }}
        >
          {tt('exitConfirm', 'Leave anyway')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
